





























































































































import Vue from 'vue'
import { createComponent, computed, watch, onMounted, ref, reactive } from '@vue/composition-api'
import { MessageBox, Message } from 'element-ui'
import { downloadFile } from '../helpers/common'
import { getPermissionList, setPermissions, deletePermissions } from '@/service/public'
import { useStore, useRoute, useRouter } from '@/hooks/common'
interface IProps {
    dialogVisible: boolean
}
export default createComponent({
    props: {
        dialogVisible: Boolean,
    },
    setup(props: IProps) {
        const store = useStore()
        const isShow = computed({
            get: () => props.dialogVisible,
            set: val => {
                if (val === false) {
                    store.commit('publicStore/SET_PERMISSION_DIALOG_STATUS', val)
                }
            },
        })
        const dialogTitle = computed(() => {
            const name = store.state.publicStore.tableRowData.name
            if (name) {
                let sliceName = name.length > 20 ? name.slice(0, 20) + '...' : name
                return `${sliceName} - 权限列表`
            }
            return '权限列表'
        })
        const permissionData: {
            visible: string[]
            download: string[]
            upload: string[]
            createNew: string[]
        } = reactive({
            visible: [],
            download: [],
            upload: [],
            createNew: [],
        })
        const loadPermissionData = async () => {
            const id = store.state.publicStore.tableRowData.id
            const data = await getPermissionList(id)
            if (data.code === 0) {
                /**
         *  PREVIEW(0, "预览"),
            UPLOAD(1, "上传"),
            DOWNLOAD(2, "下载");
            (5, "可创建文件夹");
        */
                permissionData.visible = data.data[0] || []
                permissionData.download = data.data[2] || []
                permissionData.upload = data.data[1] || []
                permissionData.createNew = data.data[5] || []
            } else {
                Message.error(data.desc || '获取权限数据失败')
            }
        }
        const usersData = ref([])
        const formNode = ref<Vue>(null)
        const formData = reactive({
            users: [],
            permissions: [],
        })
        const clearData = () => {
            permissionData.visible = []
            permissionData.download = []
            permissionData.upload = []
            permissionData.createNew = []

            formData.users = []
            formData.permissions = []
            isShowAddUsers.value = false
        }
        const deletePermission = async (data: string, type: number) => {
            const dirId = store.state.publicStore.tableRowData.id
            const deleteData = {
                permissions: [type],
                users: [data],
                dirId,
            }
            const res = await deletePermissions(deleteData)
            if (res.code === 0) {
                Message.success(res.desc || '成功')
                await loadPermissionData()
            } else {
                Message.error(res.desc || '失败')
            }
        }
        const submitFormData = async () => {
            const dirId = store.state.publicStore.tableRowData.id
            const postData = Object.assign({ dirId }, formData)
            const res = await setPermissions(postData)
            if (res.code === 0) {
                Message.success(res.desc || '成功')
                // clearData();
                formData.users = []
                formData.permissions = []
                await loadPermissionData()
            } else {
                Message.error(res.desc || '失败')
            }
        }
        const isShowAddUsers = ref<boolean>(false)
        return {
            isShow,
            loadPermissionData,
            clearData,
            deletePermission,
            dialogTitle,
            permissionData,
            formData,
            formNode,
            usersData,
            submitFormData,
            isShowAddUsers,
        }
    },
})
